module.exports = __webpack_public_path__ + "35d287ac40c2dec5dd29cc24c0268366.svg";